<template>
  <div>
    <transition name="fade">
      <b-overlay
        v-if="cartItems.length"
        :show="loader.general"
        opacity="0.50"
        rounded="sm"
      >
        <div
          class="list-view product-checkout mt-0"
        >

          <!-- Products List -->
          <e-commerce-checkout-step-cart-products />

          <!-- Checkout Options -->
          <div class="checkout-options">
            <b-overlay
              :show="loader.opciones"
              opacity="0.50"
              rounded="sm"
            >
              <b-card>
                <label class="section-label mb-1">Opciones</label>
                <!-- INPUT DE CÓDIGO DE DESCUENTO -->
                <b-form-input
                  v-model="cupon"
                  placeholder="Ingresar código de descuento"
                  @keyup.enter="checkCupon"
                />
                <small v-if="cupon && !isValidCupon">Presione <b class="text-primary">ENTER</b> para validar el código</small>

                <hr>

                <!-- DETALLES DE ORDEN -->
                <div class="price-details">
                  <h6 class="price-title">
                    Detalles de solicitud
                  </h6>
                  <ul class="list-unstyled">
                    <!-- TOTAL DE ARTÍCULOS -->
                    <li class="price-detail">
                      <div class="detail-title">
                        Total de artículos
                      </div>
                      <div class="text-success">
                        {{ cartItems.length }}
                      </div>
                    </li>
                    <!-- CÓDIGO DE DESCUENTO -->
                    <li
                      v-if="isValidCupon"
                      class="price-detail"
                    >

                      <div class="detail-title">
                        Código de descuento: <b>{{ cuponData.codigo }}</b>
                      </div>
                      <div class="text-success">
                        - {{ cuponData.descuento }} %
                      </div>
                    </li>
                  </ul>
                  <hr>
                  <!-- <ul class="list-unstyled">
                  <li class="price-detail">
                    <div class="detail-title detail-total">
                      Total
                    </div>
                    <div class="detail-amt font-weight-bolder">
                      $574
                    </div>
                  </li>
                </ul> -->

                  <b-form-checkbox
                    v-model="itemsChecked"
                    :state="itemsChecked"
                    :value="true"
                    class="custom-control-primary mb-1 mt-1"
                  >
                    He revisado mis artículos y quiero continuar con mi solicitud
                  </b-form-checkbox>
                  <b-button
                    :disabled="!itemsChecked"
                    variant="primary"
                    block
                    @click="prepareOrder()"
                  >
                    Generar solicitud
                  </b-button>
                </div>

                <small v-if="!isValidCupon">Para hacer válido un código, asegurese de presionar <b class="text-primary">ENTER</b> después de ingresarlo, de lo contrario, no será aplicado.</small>

              </b-card>
            </b-overlay>
          </div>
        </div>
      </b-overlay>
      <div
        v-else
        class="m-0 p-1 text-center"
      >
        <h5>No has agregado ningún artículo a tus solicitudes</h5>
        <b-button
          class="mt-1"
          variant="primary"
          to="/tienda"
        >
          Agregar más contenido
        </b-button>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  // BCardHeader,
  // BInputGroup,
  BFormInput,
  // BInputGroupAppend,
  // BInputGroupPrepend,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import ECommerceCheckoutStepCartProducts from './ECommerceCheckoutStepCartProducts.vue'

export default {
  components: {
    // BSV
    BButton,
    BCard,
    // BCardHeader,
    // BInputGroup,
    BFormInput,
    // BInputGroupAppend,
    // BInputGroupPrepend,
    BOverlay,
    BFormCheckbox,

    // SFC
    ECommerceCheckoutStepCartProducts,
  },
  setup() {
    const loader = ref({ general: false, opciones: false })
    const cupon = ref('')
    const cuponData = ref({})
    const isValidCupon = ref(false)
    const itemsChecked = ref(false)
    const toast = useToast()
    const cartItems = computed(() => store.state.eCommerce.cartItems)

    const checkCupon = () => {
      loader.value.opciones = true // Start loader - change ref value (true)
      store.dispatch('eCommerce/validCupon', cupon.value)
        .then(response => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Cupón aceptado',
              text: `${response.message} por un ${response.data.descuento}% de descuento`,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 20000 })
          loader.value.opciones = false // Stop loader - change ref value (false)
          cuponData.value = response.data
          isValidCupon.value = true
        }, error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en solicitud [Validar cupón]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 20000 })
          loader.value.opciones = false // Stop loader - change ref value (false)
          cuponData.value = {}
          isValidCupon.value = false
        })
    }

    const prepareOrder = () => {
      const data = {
        cupon: (cuponData.value.id) ? cuponData.value.id : '',
        elementos: cartItems.value,
      }

      loader.value.general = true // Start loader - change ref value (true)
      store.dispatch('eCommerce/sendOrder', data)
        .then(response => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud generada',
              text: response,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 20000 })
          loader.value.general = false // Stop loader - change ref value (false)
        }, error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en solicitud [Nueva Solicitud]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 20000 })
          loader.value.general = false // Stop loader - change ref value (false)
        })
    }

    return {
      loader,
      cupon,
      cuponData,
      cartItems,
      checkCupon,
      isValidCupon,
      itemsChecked,
      prepareOrder,
    }
  },
}
</script>
